module.exports = __webpack_public_path__ + "static/media/aasu (1).3b199b1e.png";